export default class TemplateContentViewModel {
  public static createEmpty(): TemplateContentViewModel {
    return new TemplateContentViewModel();
  }
  constructor(
    public Heading: string = '',
    public ModelDescription: string = '',
    public PrimaryButtonText: string = '',
    public SecondaryButtonText: string = '',
    public IsPrimaryButtonVisible: boolean = false,
    public IsSecondaryButtonVisible: boolean = false,
  ) {}
}
